/** @format */

export enum CheckoutFlow {
	LEGACY = 'legacy',
	MODERN = 'modern'
}
